// @need-translate
import {IniExtendedErrorCode} from '../../../../../../common/shared/ini-player/IniExtendedErrorCode.enum';

export const VIDEO_VIEWER_SLICE_NAME = 'videoViewer';

export enum VideoStatus {
  BeforeInitialPlay,
  Playing,
  Paused,
  Ended,
}

export const CONTROL_BOX_SHOW_TIME_MS = 2000;
export const INI_VIDEO_PLAYER_CLASSNAME = 'iniplayer-media';

export const PULL_TO_REFRESH_BLOCK_STYLE = `
html {
  overscroll-behavior-y: none;
}
body {
  overscroll-behavior-y: none;
  overflow: hidden;
}
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none';
  user-select: none;
  touch-action: pan-y;
}`;

export const HIDE_CONTROL_VIDEO_STATUS_LIST = [
  VideoStatus.BeforeInitialPlay,
  VideoStatus.Ended,
];

const PLAY_ERR_MESSAGE = '동영상 재생 중 오류가 발생했습니다.';
const REQUEST_ERR_MESSAGE = '동영상 요청 중 오류가 발생했습니다.';
// 유저 기기 문제로 DRM 재생 불가능한 경우
const DEVICE_DRM_ERR_MESSAGE_ =
  '본 콘텐츠는 DRM(저작권보호장치)이 적용된 작품으로 현재 기기에서 재생이 불가합니다.';
// HDCP가 DRM미지원이라 재생 불가능한 경우
const HDCP_DRM_ERR_MESSAGE =
  '본 콘텐츠는 DRM(저작권보호장치)이 적용된 작품으로 현재 기기(HDCP 미지원)에서 재생이 불가합니다.';
// DRM을 제공하는 우리측 문제로 재생 불가능한 경우
const SERVER_DRM_ERR_MESSAGE = 'DRM 정보를 받아오던 중 오류가 발생했습니다.';
const FAIRPLAY_BUG_ERROR_MESSAGE =
  'iOS15.0 웹브라우저 오류로 재생이 불가합니다.\n카카오페이지 앱을 이용해주세요.';
export const UNKNOWN_ERROR_MESSAGE = '알 수 없는 오류가 발생했습니다.';
const UNSUPPORTED_BROWSER =
  '영상을 재생할 수 없는 환경입니다.\niOS 사파리 / Android 크롬 일반모드에서 재생을 권장합니다.\n크롬 브라우저 > 설정 > 보호된 콘텐츠가 허용인지 확인해주세요.';

export const INI_ERROR_MESSAGE_MAP: {[key in IniExtendedErrorCode]: string} = {
  [IniExtendedErrorCode.MalformedSegment]: PLAY_ERR_MESSAGE,
  [IniExtendedErrorCode.MediaRequestCanceled]: REQUEST_ERR_MESSAGE,
  [IniExtendedErrorCode.MediaServerConnectionUnavailable]: REQUEST_ERR_MESSAGE,
  [IniExtendedErrorCode.UnsupportedCdmForDecryptDrm]: DEVICE_DRM_ERR_MESSAGE_,
  // 3002 번은 DRM 문제가 맞지만 라이센스 네트워크 요청 자체가 브라우져에서 막힌 케이스일 가능성이 높다. CORS, 웹뷰 정책 등등이 원인일 가능성이 크기 때문에 os 기본 브라우져에서 확인하는 걸 권장함.
  // retry 도 하지 않는다. 혹시 DRM 서버가 죽었을 때도 이 상태가 될 수 있다는 점은 조금 고민되는 부분임. 그래도 다른 환경에서의 시도를 유도하는게 좋을 듯.
  [IniExtendedErrorCode.DrmServerConnectionUnavailable]: UNSUPPORTED_BROWSER,
  [IniExtendedErrorCode.ParsingKeyFailed]: SERVER_DRM_ERR_MESSAGE,
  [IniExtendedErrorCode.InitializeCdmFailed]: DEVICE_DRM_ERR_MESSAGE_,
  [IniExtendedErrorCode.LicenseKeyExpired]: SERVER_DRM_ERR_MESSAGE,
  [IniExtendedErrorCode.LicenceKeyRequestCanceled]: SERVER_DRM_ERR_MESSAGE,
  [IniExtendedErrorCode.UnsupportedMimetype]: PLAY_ERR_MESSAGE,
  [IniExtendedErrorCode.MalfomedManifest]: PLAY_ERR_MESSAGE,
  [IniExtendedErrorCode.UnsupportedCodec]: PLAY_ERR_MESSAGE,
  [IniExtendedErrorCode.ManifestServerConnectionUnavailable]:
    REQUEST_ERR_MESSAGE,
  [IniExtendedErrorCode.ManifestRequestCanceled]: REQUEST_ERR_MESSAGE,
  [IniExtendedErrorCode.WrongStart]: PLAY_ERR_MESSAGE,
  [IniExtendedErrorCode.UnsupportedSystem]: PLAY_ERR_MESSAGE,
  [IniExtendedErrorCode.IniInternal]: UNKNOWN_ERROR_MESSAGE,
  [IniExtendedErrorCode.Unknown]: UNKNOWN_ERROR_MESSAGE,
  [IniExtendedErrorCode.UnsupportedHdcp]: HDCP_DRM_ERR_MESSAGE,
  [IniExtendedErrorCode.UnsupportedBrowser]: UNSUPPORTED_BROWSER,
  [IniExtendedErrorCode.GetVideoDataFailed]: REQUEST_ERR_MESSAGE,
  [IniExtendedErrorCode.OsFairplayBugVersion]: FAIRPLAY_BUG_ERROR_MESSAGE,
};

// 다시 재생을 시도해 볼 수 있는 환경을 제공해주는 에러들 (Connection 오류, 디바이스 DRM에러 또는 알수없는 에러 등)
export const CAN_RETRY_VIDEO_ERROR_LIST: IniExtendedErrorCode[] = [
  IniExtendedErrorCode.MediaRequestCanceled,
  IniExtendedErrorCode.MediaServerConnectionUnavailable,
  IniExtendedErrorCode.LicenceKeyRequestCanceled,
  IniExtendedErrorCode.ManifestServerConnectionUnavailable,
  IniExtendedErrorCode.ManifestRequestCanceled,
  IniExtendedErrorCode.WrongStart,
  IniExtendedErrorCode.IniInternal,
  IniExtendedErrorCode.Unknown,
  IniExtendedErrorCode.InitializeCdmFailed,
  IniExtendedErrorCode.UnsupportedHdcp,
];
